import cssVariables from 'tfs.css-variables'

export default {
  results: {
    padding: '2rem 2rem 0.5rem',
    borderRadius: '0.5rem',
    marginTop: '1rem',
    backgroundColor: cssVariables.colorWhite,
    width: cssVariables.containerWidth,
    margin: '0 auto',
  },
}
